export enum INTEGRATION_BUILDER_KEYS {
  ADAPTER = 'adapter',
  ALL_ADAPTERS = 'adapters-all',
  ALL_CHECK_STATUS = 'all-check-status',
  ALL_HANDLE_WEBHOOKS = 'all-handle-webhooks',
  ALL_PAYOUT = 'all-payout',
  ALL_SEND_PAYMENTS = 'all-adapters-send-payments',
  CHECK_STATUS = 'check-status',
  HANDLE_WEBHOOK = 'handle-webhooks',
  PAYOUT = 'payout',
  SEND_PAYMENT = 'send-payment',
}

export enum REDIRECT_MODE {
  POST = 'POST',
  SIMPLE = 'SIMPLE',
}
